export var ModalsActionTypes;
(function (ModalsActionTypes) {
    ModalsActionTypes["REGISTER_MODAL"] = "REGISTER_MODAL";
    ModalsActionTypes["UNREGISTER_MODAL"] = "UNREGISTER_MODAL";
    ModalsActionTypes["TOGGLE_MODAL"] = "TOGGLE_MODAL";
    ModalsActionTypes["CLOSE_MODAL"] = "CLOSE_MODAL";
})(ModalsActionTypes || (ModalsActionTypes = {}));
